import { useEffect, useState } from 'react';
import { Col, Container, Row, Dropdown } from 'react-bootstrap';
import { DashboardColors } from '../utils/Static';
import Pie from '../components/charts/Pie';
import Bar from '../components/charts/Bar';
import ChartHeading from '../components/shared/ChartHeading';
import CustomCard from './PdfCustomCard';
import DashboardTable from '../components/shared/Table';
import TableHeading from '../components/shared/TableHeading';
import Pagination from '../components/shared/TablePagination';
import { getCategoryChartDataPie, getCategoryTable, getChartData, getStatsData } from '../services/adminService/adminService';
import PerPieChart from '../components/charts/PerPieChart';
import PdfHeader from '../components/shared/PdfHeader';
import PdfFooter from '../components/shared/PdfFooter';

const PdfSite = ({ selectedRange, showImage, selectedCampagins }) => {
    const [companyId, setCompanyId] = useState(localStorage.getItem('selectedCompany'));
    const [currentPage, setCurrentPage] = useState(1);
    const [tableData, setTableData] = useState([]);
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(true);
    const [chartData, setChartData] = useState(null);
    const [ftdShow, setFtdSow] = useState();
    const [appIdShow, setAppId] = useState();
    const [appNameShow, setAppNameShow] = useState();
    const [pieChartLoading, setPieChartLoading] = useState(true);
    const [pieChartData, setPieChartData] = useState([]);
    const [pieChartPercentage, setPieChartPercentage] = useState(null);
    const [chartLoading, setChartLoading] = useState(true);
    const [totalPages, setTotalPages] = useState(5);
    // const [dropdownOpen, setDropdownOpen] = useState(false); // Control dropdown open state
    const DashboardtableHeadings = [
        "RANK",
        "APP ID",
        "APP CATEGORY",
        tableData?.length > 0 ? Object?.keys(tableData[0])[3] : "FTD’s (unique)",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[4]}` : "%FTD’s (unique)",
    ];
    const DashboardtableHeadings5 = [
        "RANK",
        "APP ICON",
        "APP ID",
        "APP NAME",
        "APP CATEGORY",
        tableData?.length > 0 ? Object?.keys(tableData[0])[5] : "FTD’s (unique)",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[6]}` : "%FTD’s (unique)",
    ];
    const DashboardtableHeadings2 = [
        "Rank",
        "APP CATEGORY",
        tableData?.length > 0 ? Object?.keys(tableData[0])[2] : "FTD’s (unique)",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[3]}` : "%FTD’s (unique)",
    ];
    const DashboardtableHeadings6 = [
        "Rank",
        "APP ICON",
        "APP NAME",
        "APP CATEGORY",
        tableData?.length > 0 ? Object?.keys(tableData[0])[4] : "FTD’s (unique)",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[5]}` : "%FTD’s (unique)",
    ];
    const DashboardtableHeadings3 = [
        "RANK",
        "APP ID",
        "APP CATEGORY",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[3]}` : "%FTD’s (unique)",
    ];
    const DashboardtableHeadings7 = [
        "RANK",
        "APP ICON",
        "APP ID",
        "APP NAME",
        "APP CATEGORY",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[5]}` : "%FTD’s (unique)",
    ];
    const DashboardtableHeadings4 = [
        "RANK",
        "APP CATEGORY",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[2]}` : "%FTD’s (unique)",
    ];
    const DashboardtableHeadings8 = [
        "RANK",
        "APP ICON",
        "APP NAME",
        "APP CATEGORY",
        tableData?.length > 0 ? `${Object?.keys(tableData[0])[4]}` : "%FTD’s (unique)",
    ];
    const tableHeadings = () => {
        if (appIdShow && ftdShow && !appNameShow) return DashboardtableHeadings;
        if (appIdShow && ftdShow && appNameShow) return DashboardtableHeadings5;
        if (appIdShow && !appNameShow) return DashboardtableHeadings3;
        if (appIdShow && appNameShow) return DashboardtableHeadings7;
        if (ftdShow && !appNameShow) return DashboardtableHeadings2;
        if (ftdShow && appNameShow) return DashboardtableHeadings6;
        if (!appNameShow) return DashboardtableHeadings4
        return DashboardtableHeadings8;
    };
    const tableBody = tableData?.map((data) => {
        console.log("App name", appNameShow)
        let index;
        if (appIdShow && ftdShow && !appNameShow) {
            index = 3;
        } else if (appIdShow && ftdShow && appNameShow) {
            index = 5;
        } else if (appIdShow && !ftdShow && !appNameShow) {
            index = 3;
        } else if (appIdShow && !ftdShow && appNameShow) {
            index = 5;
        } else if (!appIdShow && ftdShow && !appNameShow) {
            index = 2;
        } else if (!appIdShow && ftdShow && appNameShow) {
            index = 4
        } else if (!appNameShow) {
            index = 2;
        } else {
            index = 4
        }

        const row = [
            data?.Rank,
            ...(appNameShow ? [data?.iconUrl] : []),
            ...(appIdShow ? [data?.APP_ID] : []),
            ...(appNameShow ? [data?.AppName] : []),
            data?.CategoryName,
            ...(ftdShow ? [Object?.values(data)[index]] : []),
            ...(ftdShow ? [`${Object?.values(data)[index + 1]}%`] : [`${Object?.values(data)[index]}%`]),
        ];

        return row.filter(value => value != null);
    }) || [];

    const dashboardCards = stats?.dynamicResults
        ? Object.entries(stats.dynamicResults)
            .filter(([label]) => label !== "Forecasted Budget")
            .map(([label, value]) => ({
                label: label,
                value: label === "Budget" || label === "Actual Budget"
                    ? `${new Intl.NumberFormat('fr-FR').format(value)} ${stats?.currency || ''}`
                    : `${new Intl.NumberFormat('fr-FR').format(value)}`,
            }))
        : [];

    const getTable = async (page, formattedStartDate, formattedEndDate, selectedCampagins) => {
        try {
            setTableLoading(true);
            const response = await getCategoryTable(formattedStartDate, formattedEndDate, page, 7, companyId, selectedCampagins);
            console.log("Table", response?.data?.data?.data);
            setTableData(response?.data?.data?.data);
            setTotalPages(response?.data?.data?.totalPages);
            setFtdSow(response?.data?.data?.ftdEnabled);
            setAppId(response?.data?.data?.appIdEnabled);
            setAppNameShow(response?.data?.data?.appNameShow);

        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setTableLoading(false);
        } finally {
            setTableLoading(false);
        }
    };

    const getStats = async (formattedStartDate, formattedEndDate, selectedCampagins) => {
        try {
            setLoading(true);
            const response = await getStatsData(formattedStartDate, formattedEndDate, companyId, selectedCampagins);
            setStats(response?.data?.data);
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const getChart = async (formattedStartDate, formattedEndDate, selectedCampagins) => {
        try {
            setChartLoading(true);
            const response = await getChartData(formattedStartDate, formattedEndDate, companyId, selectedCampagins);
            setChartData(response?.data?.data);
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setChartLoading(false);
        } finally {
            setChartLoading(false);
        }
    };

    const getPieChart = async (formattedStartDate, formattedEndDate, selectedCampagins) => {
        try {
            setPieChartLoading(true);
            const response = await getCategoryChartDataPie(formattedStartDate, formattedEndDate, companyId, selectedCampagins);
            setPieChartData(response?.data?.data?.dashboardPie);
            setPieChartPercentage(response?.data?.data?.percDiffer)
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            setPieChartLoading(false);
        } finally {
            setPieChartLoading(false);
        }
    };
    useEffect(() => {
        console.log("Company Id again", companyId)

        const handleCompanyChange = () => {
            setCompanyId(localStorage.getItem('selectedCompany'));
        };
        window.addEventListener('user-update', handleCompanyChange);

        return () => {
            window.removeEventListener('user-update', handleCompanyChange);
        };
    }, [companyId]);
    useEffect(() => {
        if (selectedRange && selectedRange?.length === 2) {
            setCurrentPage(1);
            const [startDate, endDate] = selectedRange;
            const formatLocalDate = (date) => {
                return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
            };
            const formattedStartDate = formatLocalDate(startDate);
            const formattedEndDate = formatLocalDate(endDate);
            getStats(formattedStartDate, formattedEndDate, selectedCampagins)
            getChart(formattedStartDate, formattedEndDate, selectedCampagins)
            getPieChart(formattedStartDate, formattedEndDate, selectedCampagins)
        }
    }, [selectedRange, companyId, selectedCampagins]);

    useEffect(() => {
        if (selectedRange && selectedRange?.length === 2) {
            const [startDate, endDate] = selectedRange;
            const formatLocalDate = (date) => {
                return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
            };
            const formattedStartDate = formatLocalDate(startDate);
            const formattedEndDate = formatLocalDate(endDate);
            getTable(currentPage, formattedStartDate, formattedEndDate, selectedCampagins)
        }
    }, [selectedRange, currentPage, companyId, selectedCampagins]);

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div id="pdf" className='pdf-size'>
            <div style={{
                backgroundImage: showImage
                    ? "url('https://res.cloudinary.com/djmk3gpgr/image/upload/v1730396033/skhbjvc4cy1zxtzudjvm.png')"
                    : "none",
                backgroundSize: 'cover',
                backgroundRepeat: "no-repeat",
                backgroundPosition: 'top center'
            }}
            >
                <PdfHeader showImage={showImage} />
                <div className={`mb-5 ${showImage ? 'px-5' : ''}`} fluid>
                    <CustomCard data={dashboardCards} stats={stats} loading={loading} />
                    <Row>
                        <Col xs={8}>
                            <div className='bg-white rounded-4 p-4 my-4'>
                                <ChartHeading heading={"Performances"} />
                                <div className="d-none d-block mb-4"></div>
                                <Bar data={chartData} loading={chartLoading} />
                            </div>
                        </Col>
                        <Col xs={4}>
                            <div className='bg-white rounded-4 p-4 my-4'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <ChartHeading heading={"Category Selection"} />
                                </div>
                                <PerPieChart textWidth={"80%"} height={400} width={400} outerRadius={"60%"} innerRadius={"40%"} COLORS={DashboardColors} data={pieChartData} loading={pieChartLoading} pieChartPercentage={pieChartPercentage} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className={`${showImage ? 'pb-5' : ''}`}>
                            <div className={`p-5 bg-white rounded-4 m-1 ${showImage ? '' : ''}`}>
                                <div className='d-flex justify-content-between align-items-center mb-5'>
                                    <TableHeading heading={"By Campaign"} />
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onNext={handleNext}
                                        onPrevious={handlePrevious}
                                    />
                                </div>
                                <DashboardTable
                                    tableBody={tableBody}
                                    tableHeadings={tableHeadings()}
                                    loading={tableLoading}
                                    appNameShow={appNameShow}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
            <PdfFooter showImage={showImage} />
        </div>
    );
};

export default PdfSite;
